import { Component, inject, OnInit } from "@angular/core"
import { LogsDTO, LogsService } from "@services/logs.service"
import { DatePipe, JsonPipe } from "@angular/common"
import { ListboxModule } from "primeng/listbox"
import { SelectButtonModule } from "primeng/selectbutton"
import { FormsModule } from "@angular/forms"
import { ProgramDTO, ProgramService } from "@services/program.service"
import { ButtonModule } from "primeng/button"
import { DialogModule } from "primeng/dialog"
import { Editor2Component } from "@components/editor2/editor2.component"
import { ActivatedRoute, RouterLink } from "@angular/router"
import { environment } from "../../../../environments/environment"
import { AngularFireAuth } from "@angular/fire/compat/auth"

@Component({
  selector: "app-admin-program-logs",
  standalone: true,
  imports: [
    JsonPipe,
    ListboxModule,
    SelectButtonModule,
    FormsModule,
    ButtonModule,
    DialogModule,
    Editor2Component,
    DatePipe,
    RouterLink,
  ],
  templateUrl: "./admin-program-logs.component.html",
  styleUrl: "./admin-program-logs.component.scss",
})
export class AdminProgramLogsComponent implements OnInit {
  logsService = inject(LogsService)
  route = inject(ActivatedRoute)
  afAuth = inject(AngularFireAuth)

  popupVisibleDetail = false
  popupCurrentLog: Array<any> = []
  popupCurrentId = ""
  programService = inject(ProgramService)
  logs: Array<LogsDTO> = []
  filteredLogs: Array<LogsDTO> = []

  programsOptions: Array<{
    name: string
    value: string
    stats: number
  }> = []
  selectedPrograms: Array<string> = []

  datesOptions: Array<{
    name: string
    value: string
    stats: number
  }> = []
  selectedDates: Array<string> = []

  programsCache: { [id: string]: ProgramDTO } = {}

  async ngOnInit() {
    this.logs = await this.logsService.getAllFromCache()
    this.filteredLogs = this.logs

    const dates: Array<string> = []
    const programs: Array<string> = []

    this.logs.forEach((log) => {
      log.dates?.forEach((date) => {
        if (!dates.includes(date)) {
          this.datesOptions.push({
            name: new Date(date).toLocaleDateString("fr"),
            value: date,
            stats: this.logs.filter((l) => l.dates.includes(date)).length,
          })
          dates.push(date)
        }
      })

      log.programs?.forEach(async (progId) => {
        if (!programs.includes(progId)) {
          this.programsOptions.push({
            name: "?",
            value: progId,
            stats: this.logs.filter((l) => l.programs.includes(progId)).length,
          })
          programs.push(progId)
        }
      })
    })

    this.datesOptions.sort((a, b) => new Date(a.value).getTime() - new Date(b.value).getTime())

    this.programsOptions = await Promise.all(
      this.programsOptions.map(async (p) => {
        const program = await this.programService.get(p.value)
        p.name = program?.name + " - " + program?.date + " - " + program?.town
        this.programsCache[program?.id || ""] = program
        return p
      }),
    )

    const programId = this.route.snapshot.params["id"] || ""
    if (programId) {
      this.selectedPrograms.push(programId)
      this.filtering()
    }

    this.datesOptions = [...this.datesOptions] // WTF ?? no working otherwise??
  }

  open(logId: string) {
    console.log("open,", logId, this.selectedDates)
    const log = this.logs.find((l) => l.id === logId)
    if (log && this.selectedPrograms.length === 1) {
      this.popupVisibleDetail = true
      //@ts-ignore
      this.popupCurrentLog = log["logs-" + this.selectedPrograms[0]]
      this.popupCurrentId = logId
    }
  }

  filtering() {
    this.filteredLogs = this.logs.filter((log) => {
      return (
        (this.selectedPrograms.length === 0 ||
          log.programs.filter((pId) => this.selectedPrograms.includes(pId)).length > 0) &&
        (this.selectedDates.length === 0 || log.dates.filter((date) => this.selectedDates.includes(date)).length > 0)
      )
    })
    if (this.selectedPrograms.length === 1) {
      this.filteredLogs.sort((a, b) => {
        //@ts-ignore
        return b["logs-" + this.selectedPrograms[0]].length - a["logs-" + this.selectedPrograms[0]].length
      })
    }
  }

  async exportCSV() {
    const params = {
      ids: this.filteredLogs.map((x) => x.id),
    }
    const user = await this.afAuth.currentUser
    const token = await user?.getIdToken()

    const req = new XMLHttpRequest()
    req.responseType = "blob"
    req.open("POST", environment.exportUrl, true)
    req.setRequestHeader("Authorization", "Bearer " + token)
    req.send(JSON.stringify(params))

    return new Promise((resolve, reject) => {
      req.onload = (res) => {
        if ((res.target as any)?.status === 200) {
          this.saveAsFile(res, `backstage-users-${new Date().toISOString()}.csv`)
          resolve(null)
        } else {
          console.error("Error", res.target)
          reject()
        }
      }
    })
  }

  saveAsFile(data: any, name: string) {
    const link = document.createElement("a") as any
    document.body.appendChild(link)
    link.style = "display: none"
    const url = (window as any).URL.createObjectURL(data.target.response)
    link.href = url
    link.download = name
    link.click()
    ;(window as any).URL.revokeObjectURL(url)
    link.remove()
  }
}
